import React from 'react';
import whitelistProps from 'admin-components/utils/whitelistProps';
import { StyledHorizontalRule } from './HorizontalRule.styles';
import { propTypes, defaultProps, propDescriptions } from './HorizontalRule.props';

const HorizontalRule = (props) => <StyledHorizontalRule data-id="HorizontalRule" {...whitelistProps(props, propTypes)} />;

HorizontalRule.propTypes = propTypes;
HorizontalRule.defaultProps = defaultProps;
HorizontalRule.propDescriptions = propDescriptions;

export default HorizontalRule;
